export const ALERTS_STATE = 'alerts'

export const ALERT_DISPLAY = 'ALERT_DISPLAY'
export const ALERT_REMOVE = 'ALERT_REMOVE'
export const ALERT_PROCESS = 'ALERT_PROCESSED'
